import { Download, ExternalLink, FolderOpen } from "lucide-react";

const MULTITRACK_DOWNLOAD_URL =
  "https://drive.google.com/drive/folders/1AJ-uGxaqtC1xyrnsZ4gfSyDwH3BQimkh?usp=sharing";

export const DownloadResourcesBanner = () => (
  <section
    aria-labelledby="download-resources-title"
    className="mb-8 md:mb-10 overflow-hidden rounded-2xl border border-white/[0.08] bg-[#0A0A0C]/90 shadow-[0_24px_70px_-40px_rgba(0,0,0,0.9)]"
  >
    <div className="relative isolate px-5 py-5 sm:px-6 md:px-8 md:py-7">
      <div className="absolute inset-0 -z-10 bg-[radial-gradient(circle_at_top_left,rgba(197,160,89,0.18),transparent_34%),linear-gradient(135deg,rgba(255,255,255,0.055),transparent_44%)]" />
      <div className="flex flex-col gap-5 md:flex-row md:items-center md:justify-between">
        <div className="flex min-w-0 gap-4">
          <div className="hidden h-12 w-12 shrink-0 items-center justify-center rounded-xl border border-[#C5A059]/25 bg-[#C5A059]/10 text-[#C5A059] sm:flex">
            <FolderOpen className="h-5 w-5" strokeWidth={1.8} aria-hidden="true" />
          </div>
          <div className="min-w-0">
            <p className="text-xs font-semibold uppercase tracking-[0.2em] text-[#C5A059]">
              Course Resources
            </p>
            <h2
              id="download-resources-title"
              className="mt-2 font-heading text-2xl font-semibold leading-tight text-white md:text-3xl"
            >
              Download Multitrack Files
            </h2>
            <p className="mt-2 max-w-2xl text-sm leading-6 text-zinc-400 sm:text-base">
              Access all project stems and practice files used throughout the
              mixing class.
            </p>
          </div>
        </div>

        <a
          href={MULTITRACK_DOWNLOAD_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex w-full items-center justify-center gap-2 rounded-full bg-[#C5A059] px-5 py-3 text-sm font-semibold text-[#050505] shadow-[0_16px_35px_-22px_rgba(197,160,89,0.9)] transition-all hover:-translate-y-0.5 hover:bg-[#d7b36a] focus:outline-none focus:ring-2 focus:ring-[#C5A059] focus:ring-offset-2 focus:ring-offset-[#0A0A0C] sm:w-auto"
        >
          <Download className="h-4 w-4" strokeWidth={2} aria-hidden="true" />
          <span>Open Download Folder</span>
          <ExternalLink className="h-3.5 w-3.5" strokeWidth={2} aria-hidden="true" />
        </a>
      </div>
    </div>
  </section>
);
